// This SVG file import will be handled by webpack's raw-text loader.
// This means that imageIcon will hold the source SVG.
import CKEditorPlugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/pencil.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

/**
 * Custom Html Buttons
 * 
 * Usage:
 * 
 * 1. In the editor config add a list of custom buttons like so:
 * {
 *   ...
 *   "customHtmlButtons": [
 *     {
 *       name: 'some_custom_button',
 *       label: 'button label',
 *       html: '<p>html content that gets <strong>inserted</strong></p>',
 *       icon: 'pencil.png',      // optional
 *     }
 *   ]
 * }
 * 
 * 2. Add the button to the toolbar using its `name`.
 * {
 *   ...
 *   "toolbar": [
 *     ...
 *     'some_custom_button'
 *   ]
 * }
 */

class CustomHtmlButtons extends CKEditorPlugin {
    static get pluginName() {
        return 'CustomHtmlButtons';
    }

    init() {
        const definitions = this.editor.config.get('customHtmlButtons') || [];

        definitions.forEach(definition => this.createToolbarButton(definition));
    }

    createToolbarButton(definition) {
        const editor = this.editor;
        
        editor.ui.componentFactory.add(definition.name, locale => {
            const button = new ButtonView( locale );

            button.set({
                label: definition.label,
                icon: definition.icon || imageIcon,
                tooltip: true,
                withText: definition.label && definition.label.trim().length > 0,
            });

            button.on('execute', () => {
                const content = definition.html;
                const model = editor.model;

                if (content && typeof content === 'string' && content.length > 0) {
                    model.change(writer => {
                        const textNode = writer.createText(content);
                        model.insertContent(textNode, model.document.selection);
                    });
                }
            });

            return button;
        });
    }
}

export default CustomHtmlButtons;